import React from 'react'
import styled from 'styled-components'

import Layout from './components/Layout'
import PopupPanel from './components/PopupPanel'

// Context.
import { StoreContext } from './store'
import { StoreCodeContext } from './contexts/StoreCodeContext'
import { OffsetContext } from './contexts/OffsetContext'
import { PopupPanelContext } from './contexts/PopupPanelContext'

const SApp = styled.div`
    background-color: black;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    overflow: hidden;
`

function App() {
	return (
		<SApp>
			<StoreContext>
				<StoreCodeContext>
					<OffsetContext>
						<PopupPanelContext>
							<Layout />
							<PopupPanel />
						</PopupPanelContext>
					</OffsetContext>
				</StoreCodeContext>
			</StoreContext>
		</SApp>
	)
}

export default App
